(() => {
  const CART_TTL = 30 * 60 * 1000;
  const KEY = 'cvv_cart_last_activity';

  const markCartActivity = () => localStorage.setItem(KEY, String(Date.now()));

  const clearExpiredCart = async () => {
    const last = Number(localStorage.getItem(KEY) || 0);
    if (!last) {
      markCartActivity();
      return;
    }
    if (Date.now() - last < CART_TTL) return;

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      localStorage.removeItem(KEY);
      window.location.reload();
    } catch (error) {
      console.warn('Winkelmandje kon niet automatisch worden geleegd.', error);
    }
  };

  const hideCollectionsMenuItem = () => {
    document.querySelectorAll('header a, header button, [role="navigation"] a, [role="navigation"] button').forEach((element) => {
      if ((element.textContent || '').trim().toLowerCase() === 'collecties') {
        const item = element.closest('li') || element;
        item.style.display = 'none';
      }
    });
  };

  const collapseSizeChart = () => {
    document.querySelectorAll('accordion-item').forEach((item) => {
      const title = item.querySelector('.accordion-item__button-title-text');
      if ((title?.textContent || '').trim().toLowerCase() !== 'maattabel') return;
      if (item.dataset.cvvSizeInitialised === 'true') return;

      item.dataset.cvvSizeInitialised = 'true';
      item.removeAttribute('data-opened');

      const button = item.querySelector('[data-accordion-button]');
      const content = item.querySelector('[data-accordion-content]');

      button?.setAttribute('aria-expanded', 'false');

      if (content) {
        content.style.maxHeight = '0px';
        content.style.minHeight = '0px';
        content.style.overflow = 'hidden';
      }
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('button, a, input');
    if (!target) return;

    const text = (target.textContent || target.value || '').toLowerCase();

    if (
      text.includes('winkelmand') ||
      text.includes('cart') ||
      text.includes('toevoegen') ||
      text.includes('add to cart') ||
      target.closest('form[action*="/cart/add"]')
    ) {
      markCartActivity();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const action = event.target?.getAttribute?.('action') || '';
    if (action.includes('/cart')) markCartActivity();
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    hideCollectionsMenuItem();
    collapseSizeChart();
    clearExpiredCart();
    setInterval(clearExpiredCart, 60000);
  });

  document.addEventListener('shopify:section:load', collapseSizeChart);

  new MutationObserver(() => {
    hideCollectionsMenuItem();
    collapseSizeChart();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();